import React, { useEffect, useState } from "react";
import axios from "axios";
import { api } from "../utils/Api";
import {
	Typography,
	Flex,
	Button,
	notification,
	Row,
	Col,
	Tag,
	Input,
	Select,
	Popconfirm,
	Checkbox,
} from "antd";
import Layout from "../layout/Layout";
import { CustomSpinner, CustomTable } from "../utils/CustomComponents";
import { EditFilled, DeleteFilled } from "@ant-design/icons";
import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";
dayjs.extend(duration);

const { Search } = Input;
const { Text } = Typography;

const statusOptions = [
	{
		value: "All",
		label: "All",
	},
	{
		value: "New",
		label: "New",
	},
	{
		value: "In Progress",
		label: "In Progress",
	},
	{
		value: "Closed",
		label: "Closed",
	},
];

const optionsType = [
	{
		value: "All",
		label: "All",
	},
	{
		value: "ETICKET",
		label: "ETICKET",
	},
	{
		value: "JAP",
		label: "JAP",
	},
];

const TaskDashboard = ({ history }) => {
	const [loading, setLoading] = useState(false);
	const [taskList, setTaskList] = useState([]);
	const [apiNotification, contextHolder] = notification.useNotification();
	const [status, setStatus] = useState("All");
	const [type, setType] = useState("All");

	const openNotification = (type, message, description) => {
		apiNotification[type]({
			message: message,
			description: description,
		});
	};

	/**
	 ** Options header (columns)
	 */
	const columns = [
		{
			title: "",
			dataIndex: "edit",
			width: 100,
			render: (_, record) => {
				return (
					<Row gutter={16}>
						<Col span={12}>
							<Button
								type="primary"
								icon={<EditFilled twoToneColor={"white"} />}
								onClick={(e) => history.push(`/task/update/${record.id}`)}
							/>
						</Col>
						{(localStorage.getItem("email") === "eliud@gmail.com" ||
							localStorage.getItem("email") === "pc@57concrete.com" ||
							localStorage.getItem("email") === "jc@57concrete.com" ||
							localStorage.getItem("email") === "gg@57xgroup.com" ||
							localStorage.getItem("email") === "ec@57concrete.com") && (
							<Col span={12}>
								<Popconfirm
									title="Delete the task"
									description="Are you sure to delete this task?"
									okText="Yes"
									cancelText="No"
									onConfirm={() => deleteTask(record.id)}
								>
									<Button
										danger
										type="primary"
										htmlType="button"
										loading={loading}
										icon={<DeleteFilled />}
									/>
								</Popconfirm>
							</Col>
						)}
					</Row>
				);
			},
		},
		{
			title: "Number",
			dataIndex: "number",
			key: "number",
			render: (value) => {
				return <Text strong>{value}</Text>;
			},
		},
		{
			title: "Date",
			dataIndex: "date",
			key: "date",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Title",
			dataIndex: "title",
			key: "title",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Description",
			dataIndex: "description",
			key: "description",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Type",
			dataIndex: "type",
			key: "type",
			render: (value) => {
				return (
					<Row gutter={[16, 16]}>
						{value.map((item) => {
							return (
								<Col span={24}>
									<Tag color={item === "ETICKET" ? "red" : "blue"}>{item}</Tag>
								</Col>
							);
						})}
					</Row>
				);
			},
		},
		{
			title: "Status",
			dataIndex: "status",
			key: "status",
			render: (value) => {
				let color = "default";
				switch (value) {
					case "New":
						color = "blue";
						break;

					case "In Progress":
						color = "yellow";
						break;

					case "Closed":
						color = "green";
						break;

					default:
						break;
				}
				return <Tag color={color}>{value}</Tag>;
			},
		},
		{
			title: "Open Time",
			dataIndex: "openTime",
			key: "openTime",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Closed Date",
			dataIndex: "closedDate",
			key: "closedDate",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Created By",
			dataIndex: "createdBy",
			key: "createdBy",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Authorized By",
			dataIndex: "authorizedBy",
			key: "authorizedBy",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Bill ID",
			dataIndex: "billId",
			key: "billId",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Paid",
			dataIndex: "paid",
			key: "paid",
			render: (value) => {
				return <Checkbox checked={value} />;
			},
		},
		{
			title: "Approved",
			dataIndex: "approved",
			key: "approved",
			render: (value) => {
				return <Checkbox checked={value} />;
			},
		},
		{
			title: "Approved Date",
			dataIndex: "approvedDate",
			key: "approvedDate",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Approved By",
			dataIndex: "approvedBy",
			key: "approvedBy",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
	];

	useEffect(() => {
		getTasks("");
	}, []);

	const deleteTask = async (id) => {
		setLoading(true);

		const url = api + `/task/delete/${id}`;
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.delete(url);
			if (data.success) {
				openNotification("info", "Info", data.message);
				getTasks("");
			} else {
				openNotification("error", "Error", data.message);
			}
		} catch (err) {
			console.error(err.message);
			return null;
		}
	};

	const getTasks = async (term) => {
		setLoading(true);

		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };
		const url = api + `/task/list?&term=${term}&type=${type}&status=${status}`;

		try {
			const { data } = await axios.get(url);
			let list = [];

			if (data.success) {
				data.payload.map((item, index) => {
					const createdAt = dayjs(new Date(item.createdAt));
					const currentDate = item.closedDate
						? dayjs(new Date(item.closedDate))
						: dayjs();

					const diffInMs = currentDate.diff(createdAt);

					const dur = dayjs.duration(diffInMs);

					const days = Math.floor(dur.asDays());
					const hours = dur.hours();

					list.push({
						key: index,
						id: item._id,
						number: item.number,
						createdBy: item.createdBy.name,
						authorizedBy: item.authorizedBy.name,
						date: Intl.DateTimeFormat("en-US", {
							month: "numeric",
							year: "numeric",
							day: "numeric",
							hour: "2-digit",
							minute: "2-digit",
							second: "2-digit",
						}).format(new Date(item.createdAt)),
						closedDate: item.closedDate
							? Intl.DateTimeFormat("en-US", {
									month: "numeric",
									year: "numeric",
									day: "numeric",
									hour: "2-digit",
									minute: "2-digit",
									second: "2-digit",
								}).format(new Date(item.closedDate))
							: "NA",
						title: item.title,
						description: item.description,
						type: item.type,
						status: item.status,
						billId: item.billId,
						paid: item.paid,
						openTime: `${days} days and ${hours} hours`,
						approved: item.approved,
						approvedDate: item.approvedDate
							? Intl.DateTimeFormat("en-US", {
									month: "numeric",
									year: "numeric",
									day: "numeric",
									hour: "2-digit",
									minute: "2-digit",
									second: "2-digit",
								}).format(new Date(item.approvedDate))
							: "NA",
						approvedBy: item.approvedBy ? item.approvedBy.name : "N/A",
					});
				});
				setTaskList(list);
			} else {
				openNotification("error", "Error", data.message);
			}

			setLoading(false);
		} catch (err) {
			console.error(err.message);
			openNotification("error", "Error", err.message);
			return null;
		}
	};

	const RenderTable = () => {
		return (
			<Flex gap={"middle"} vertical>
				<Row gap={[16, 16]}>
					<Col>
						<Button
							type="primary"
							onClick={() => history.push("/task/new")}
							size="large"
						>
							Add new task
						</Button>
					</Col>
				</Row>

				<CustomTable columns={columns} data={taskList} isScroll={true} />
			</Flex>
		);
	};

	const onSearch = (value, _e, info) => {
		if (info?.source === "input") {
			getTasks(value);
		}
	};

	const filterOption = (input, option) =>
		(option?.label ?? "").toLowerCase().includes(input.toLowerCase());

	const RenderSearch = () => {
		return (
			<Flex gap={10}>
				<Select
					showSearch
					placeholder={`Select status`}
					optionFilterProp="children"
					size="large"
					onChange={(value) => setStatus(value)}
					filterOption={filterOption}
					options={statusOptions}
					disabled={loading}
					defaultValue={"All"}
					value={status}
					style={{
						width: "200px",
					}}
				/>
				<Select
					showSearch
					placeholder={`Select type`}
					optionFilterProp="children"
					size="large"
					onChange={(value) => setType(value)}
					filterOption={filterOption}
					options={optionsType}
					disabled={loading}
					defaultValue={"All"}
					value={type}
					style={{
						width: "200px",
					}}
				/>
				<Search
					placeholder="Search"
					enterButton
					onSearch={onSearch}
					allowClear
					style={{
						width: 400,
					}}
					size="large"
					loading={loading}
					disabled={loading}
				/>
			</Flex>
		);
	};

	return (
		<Layout title="Task Dashboard" description="Dashboard">
			{contextHolder}
			<Flex vertical gap={"large"}>
				<RenderSearch />
				{loading ? <CustomSpinner /> : <RenderTable />}
			</Flex>
		</Layout>
	);
};

export default TaskDashboard;
